(() => {
  if (window.missRetailCheckoutLoaded) return;
  window.missRetailCheckoutLoaded = true;
  window.missPiercingOptionLoaded = true;

  const feeVariantId = 57317452677498;
  const base = window.Shopify?.routes?.root || '/';
  const root = () => document.querySelector('[data-retail-checkout]');
  let queue = Promise.resolve();
  let checkoutRequested = false;
  const locked = new Set();

  function lock(on) {
    if (on) {
      document.querySelectorAll('#checkout, cart-items input, cart-items button').forEach(element => {
        if (!element.disabled) {
          locked.add(element);
          element.disabled = true;
        }
      });
    } else {
      locked.forEach(element => { element.disabled = false; });
      locked.clear();
    }
  }

  function reportError() {
    const status = root();
    if (status) {
      status.textContent = status.dataset.errorMessage;
      status.hidden = false;
    }
  }

  function clearError() {
    const status = root();
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }
  }

  function isRetiredAttribute(key) {
    return key.startsWith('Perforación · ') || key.startsWith('Presentación · ') || key === 'Presentación de los pendientes';
  }

  async function requestCart(body) {
    const response = await fetch(base + (body ? 'cart/update.js' : 'cart.js'), {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {Accept: 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})},
      ...(body ? {body: JSON.stringify(body)} : {})
    });
    if (!response.ok) throw Error('Cart unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw Error('Invalid cart');
    return cart;
  }

  async function removeRetiredPreparation() {
    const cart = await requestCart();
    const attributes = Object.fromEntries(Object.entries(cart.attributes || {})
      .filter(([key, value]) => isRetiredAttribute(key) && value !== '')
      .map(([key]) => [key, '']));
    const fees = cart.items.filter(item => Number(item.variant_id) === feeVariantId);
    if (!fees.length && !Object.keys(attributes).length) return false;
    if (fees.some(item => typeof item.key !== 'string' || !item.key)) throw Error('Invalid fee line');
    const updates = Object.fromEntries(fees.map(item => [item.key, 0]));
    const updated = await requestCart({
      ...(fees.length ? {updates} : {}),
      ...(Object.keys(attributes).length ? {attributes} : {})
    });
    if (updated.items.some(item => Number(item.variant_id) === feeVariantId) ||
        Object.entries(updated.attributes || {}).some(([key, value]) => isRetiredAttribute(key) && value !== '')) {
      throw Error('Preparation removal not confirmed');
    }
    return true;
  }

  function serialized(task) {
    const pending = queue.catch(() => {}).then(task);
    queue = pending;
    return pending;
  }

  async function refreshCart() {
    if (!root() || checkoutRequested) return;
    try {
      await serialized(async () => {
        if (!root() || checkoutRequested) return;
        lock(true);
        try {
          const changed = await removeRetiredPreparation();
          clearError();
          if (changed && !checkoutRequested) location.reload();
        } finally {
          if (!checkoutRequested) lock(false);
        }
      });
    } catch {
      reportError();
    }
  }

  async function checkout() {
    if (!root() || checkoutRequested) return;
    checkoutRequested = true;
    lock(true);
    clearError();
    try {
      await serialized(async () => {
        const fiscal = window.missRetailFiscal;
        if (!fiscal || typeof fiscal.prepare !== 'function' || typeof fiscal.save !== 'function') throw Error('Checkout unavailable');
        if (!await fiscal.prepare()) return;
        await fiscal.save();
        await removeRetiredPreparation();
        if (typeof fiscal.checkoutUrl !== 'function') throw Error('Checkout unavailable');
        location.assign(fiscal.checkoutUrl());
      });
    } catch {
      reportError();
    } finally {
      checkoutRequested = false;
      lock(false);
    }
  }

  document.addEventListener('click', event => {
    if (!root() || !event.target.closest?.('#checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);

  document.addEventListener('submit', event => {
    if (!root() || event.target.id !== 'cart' || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
  }

  refreshCart();
})();
